import { useEffect } from 'react';

const ZohoChat = () => {
  useEffect(() => {
    if (document.getElementById('zsiqscript')) return;

    const initScript = document.createElement('script');
    initScript.innerHTML = ` window.$zoho = window.$zoho || {};
      $zoho.salesiq = $zoho.salesiq || { ready: function() {} };`;

    const chatScript = document.createElement('script');
    chatScript.src =
      'https://salesiq.zohopublic.com/widget?wc=siqf49d71104587cee4fa4916a2a956127ec29fa83d3ba6c61598462b5185800add';
    chatScript.defer = true;
    chatScript.id = 'zsiqscript';
    document.body.appendChild(initScript);
    document.body.appendChild(chatScript);
  }, []);
  return null;
};

export default ZohoChat;
